export default "__VITE_ASSET__EzOfwddP__"